import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ConfirmationModal, useOverlayContext } from 'seagull';
import { CopyToClipboard } from '~/components/CopyToClipboard/CopyToClipboard';
import { CopyLinkForProposalModal } from '~/hooks/useOpenCopyLinkModal/CopyLinkForProposalModal';
import { useLocaleKeys } from '~/i18n';
export function useOpenCopyLinkModal() {
    const { t: copyLinkTexts } = useLocaleKeys('hooks.copyLink');
    const { t: commonTexts } = useLocaleKeys('common');
    const overlayContext = useOverlayContext();
    const openCopyLinkForAgreement = useCallback(function openCopyLinkModal(props) {
        const { testId, url } = props;
        return overlayContext.showModal({
            biName: 'copy_link_modal_confirm',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    bi: {
                        primaryButton: {
                            name: 'copy_agreement_link_close'
                        },
                        secondaryButton: {
                            name: 'copy_agreement_link_cancel'
                        }
                    },
                    title: copyLinkTexts.title(),
                    content: /*#__PURE__*/ _jsx(CopyToClipboard, {
                        testId: testId,
                        value: url
                    }),
                    primaryButtonLabel: commonTexts.buttons.close(),
                    onPrimaryButtonClick: dismissModal,
                    onCloseButtonClick: dismissModal
                });
            }
        });
    }, []);
    const openCopyLinkForProposal = (props)=>{
        const { testId, url, recipients } = props;
        if (recipients) {
            return overlayContext.showModal({
                biName: 'copy_link_modal_confirm_2',
                closeOnClickOutside: true,
                closeOnEscapeKey: true,
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(ConfirmationModal, {
                        bi: {
                            primaryButton: {
                                name: 'copy_proposal_link_close'
                            },
                            secondaryButton: {
                                name: 'copy_proposal_link_cancel'
                            }
                        },
                        width: '900px',
                        title: copyLinkTexts.title(),
                        content: /*#__PURE__*/ _jsx(CopyLinkForProposalModal, {
                            testId: testId,
                            recipients: recipients
                        }),
                        primaryButtonLabel: commonTexts.buttons.close(),
                        onPrimaryButtonClick: dismissModal,
                        onCloseButtonClick: dismissModal
                    });
                }
            });
        } else if (url) {
            return openCopyLinkForAgreement({
                testId,
                url
            });
        }
    };
    return {
        openCopyLinkForAgreement,
        openCopyLinkForProposal
    };
}
